module.exports = __webpack_public_path__ + "img/CF_2Y.1.4f4fb055.jpg";